import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { isValid, parseISO } from "date-fns";
import { memo, useCallback, useEffect, useLayoutEffect, useState, } from "react";
import ReactDatepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Timepicker from "react-time-picker";
import { Button } from "../../button";
import { Label } from "../../form/label";
import { IconV2 } from "../../icon_v2";
import { useAdvancedDatePicker } from "./AdvancedDatePickerProvider";
import "./date.css";
import "./time.css";
const Calendar = ({ i18nStrings, showTimePicker = true, startOfWeek, dateFormat = "yyyy-MM-dd", pickerValue, maxDate, minDate, dateRangeOptions, onChange: onDateChanged, showClearButton, clearButtonLabel, onClearDateRange, }) => {
    var _a, _b;
    const { value, handleDateChangedValue, handleDropdownState, handleSelectedSuggestion, } = useAdvancedDatePicker();
    const [formatRangeValue, setFormatRangeValue] = useState({
        startDate: "",
        endDate: "",
    });
    if ((value === null || value === void 0 ? void 0 : value.startDate) instanceof Date)
        value.startDate = value.startDate.toISOString();
    if ((value === null || value === void 0 ? void 0 : value.endDate) instanceof Date)
        value.endDate = value.endDate.toISOString();
    const [startDate, setStartDate] = useState(value ? parseISO(value.startDate) : new Date());
    const [endDate, setEndDate] = useState(value ? parseISO(value.endDate) : null);
    const [startTime, setStartTime] = useState(value
        ? new Date(value.startDate).toTimeString()
        : new Date().toTimeString());
    const [endTime, setEndTime] = useState(value ? new Date(value.endDate).toTimeString() : new Date().toTimeString());
    const onChange = useCallback((dates) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const [start, end] = dates;
        if (start)
            setStartDate(start);
        setEndDate(end);
        handleDateChangedValue(null);
    }, [handleDateChangedValue]);
    useEffect(() => {
        if (endDate !== null) {
            const startDateString = startDate.toDateString();
            const endDateString = endDate.toDateString();
            const startTimeString = startTime.toLocaleString();
            const endTimeString = endTime.toLocaleString();
            const pendingStart = new Date(`${startDateString} ${startTimeString !== null && startTimeString !== void 0 ? startTimeString : "00:00:00"}`);
            const pendingEnd = new Date(`${endDateString} ${endTimeString !== null && endTimeString !== void 0 ? endTimeString : "23:59:59"}`);
            const now_utc_start = Date.UTC(pendingStart.getUTCFullYear(), pendingStart.getUTCMonth(), pendingStart.getUTCDate(), pendingStart.getUTCHours(), pendingStart.getUTCMinutes(), pendingStart.getUTCSeconds());
            const now_utc_end = Date.UTC(pendingEnd.getUTCFullYear(), pendingEnd.getUTCMonth(), pendingEnd.getUTCDate(), pendingEnd.getUTCHours(), pendingEnd.getUTCMinutes(), pendingEnd.getUTCSeconds());
            const localStartDate = new Date(now_utc_start).toISOString();
            const localEndDate = new Date(now_utc_end).toISOString();
            setFormatRangeValue({
                startDate: localStartDate,
                endDate: localEndDate,
            });
        }
    }, [startDate, endDate, startTime, endTime]);
    // Setting default date range value
    useLayoutEffect(() => {
        if (dateRangeOptions === null || dateRangeOptions === void 0 ? void 0 : dateRangeOptions.setDefault) {
            setStartDate(dateRangeOptions.startDate);
            setEndDate(dateRangeOptions.endDate);
            setStartTime(dateRangeOptions.startTime);
            setEndTime(dateRangeOptions.endTime);
        }
    }, [dateRangeOptions]);
    const onApply = () => {
        // check if dates are valid
        if (isValid(parseISO(formatRangeValue.startDate)) &&
            isValid(parseISO(formatRangeValue.endDate))) {
            handleDateChangedValue(formatRangeValue);
            handleDropdownState(false);
            handleSelectedSuggestion({ amount: null, unit: null });
            onDateChanged(formatRangeValue);
        }
    };
    const handleClearSchedule = () => {
        if (onClearDateRange) {
            onClearDateRange();
        }
        // handleDateChangedValue(null);
        // onDateChanged({
        //   startDate: "",
        //   endDate: "",
        // });
        // setEndDate(null);
        // setStartTime(null);
        // setEndTime(null);
        // setFormatRangeValue({
        //   startDate: "",
        //   endDate: "",
        // });
    };
    return (_jsxs(_Fragment, { children: [_jsx(ReactDatepicker, { selected: startDate,
                value: pickerValue,
                onChange,
                startDate,
                endDate,
                selectsRange: true,
                inline: true,
                dateFormat,
                calendarStartDay: startOfWeek,
                minDate,
                maxDate }), " ", _jsx("div", { className: "py-3", children: showTimePicker && (_jsxs("div", { className: "date-range-picker-time flex w-full", children: [_jsx("div", { className: "mr-3 w-full", children: _jsx(Label, { label: (_a = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.startTimeLabel) !== null && _a !== void 0 ? _a : "Start time", name: "daterange-picker-start-time", children: _jsx(Timepicker, { value: startTime, onChange: (val) => setStartTime(val !== null && val !== void 0 ? val : "00:00"), hourPlaceholder: "hh", minutePlaceholder: "mm", secondPlaceholder: "ss", disableClock: true, nativeInputAriaLabel: "daterangepicker-start-time", clearIcon: _jsx(IconV2, { type: "fa", icon: {
                                            icon: ["far", "xmark"],
                                            fixedWidth: true,
                                            size: "lg",
                                        } }), amPmAriaLabel: "Select AM/PM", hourAriaLabel: "Hour", minuteAriaLabel: "Minute", clearAriaLabel: "Clear Value", clockAriaLabel: "Toggle Clock" }) }) }), _jsx("div", { className: "w-full", children: _jsx(Label, { label: (_b = i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.endTimeLabel) !== null && _b !== void 0 ? _b : "End time", name: "daterange-picker-end-time", children: _jsx(Timepicker, { value: endTime, onChange: (val) => setEndTime(val !== null && val !== void 0 ? val : "00:00"), hourPlaceholder: "hh", minutePlaceholder: "mm", secondPlaceholder: "ss", disableClock: true, nativeInputAriaLabel: "daterangepicker-end-time", clearIcon: _jsx(IconV2, { type: "fa", icon: {
                                            icon: ["far", "xmark"],
                                            fixedWidth: true,
                                            size: "lg",
                                        } }), amPmAriaLabel: "Select AM/PM", hourAriaLabel: "Hour", minuteAriaLabel: "Minute", clearAriaLabel: "Clear Value", clockAriaLabel: "Toggle Clock" }) }) })] })) }), showClearButton && (_jsx("div", { className: "[&>button]:w-full", children: _jsx(Button, { variant: "secondary-destructive", id: "calendarClearBtn", onClick: handleClearSchedule, children: clearButtonLabel }) })), _jsxs("div", { className: "border-light dark:border-dark-light mt-3 flex w-full flex-row-reverse border-t pt-3 [&>button]:w-full", children: [_jsx(Button, { variant: "primary", id: "calendarApplyBtn", onClick: onApply, children: "Apply" }), _jsx("div", { className: "mr-3" }), _jsx(Button, { variant: "secondary", id: "calendarCancelBtn", onClick: () => handleDropdownState(false), children: "Cancel" })] })] }));
};
export default memo(Calendar);
